const Loading = ({ centered, className = '', ...props }) => {
    const spinner = (
        <div className={`ss-loading ss-loading-dots ${className}`} role='status' {...props}>
            <span className='visually-hidden'>Loading...</span>
        </div>
    )

    return centered ? <div className='ss-flex ss-ustify-center'>{spinner}</div> : spinner
}

export default Loading
